import type { FieldErrors, UseFormRegister,UseFormSetValue } from "react-hook-form";
import { useLookupTypeFraisQuery } from "../../stores/OkOkStore";
import type { Fond, FondInsert,FondUpdate } from "../../types/Fond";
import type { TypeFrais, TypeFraisFond } from "../../types/TypeFrais";
import { FloatingPostfixInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useEffect, useState } from "react";
import { useTrads } from "../../contexts/trads/useTrads";

interface FondFraisSelectorParams {
    type_frais:TypeFraisFond[],
    setValue: UseFormSetValue< FondUpdate>,
    register:UseFormRegister<FondUpdate>,
    errors:FieldErrors<Partial<Fond>>
}

export function FondFraisSelector({type_frais,setValue,register,errors}:FondFraisSelectorParams){
    const { data, error, isLoading } = useLookupTypeFraisQuery({});
    const {translate}=useTrads();

    const [type,setType]=useState<TypeFraisFond[]>(type_frais);
    function RemoveTypeFrais(idx: number){
        const tmp=type.filter((_,v)=> v!=idx );
        setType(tmp)
    }
    function AddTypeFrais(tmpfrais:TypeFrais){
        setType([...type,{name:tmpfrais.name,restriction:0,type_frais_id:tmpfrais.id,ordre:0,fond_id:0,description:''}])
    }

    function alreadySelected(tf:TypeFrais):boolean{
        return type.find(
            (elem:TypeFraisFond)=>elem.type_frais_id===tf.id
        )==undefined;
    }

     useEffect(()=>{
        setValue("type_frais",type);
     },[type,setValue])

     console.log(error);
    return (

    error ? (
       <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

    ) : isLoading ? (
        <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
    ) : data ? (
        <>
        {data.data.filter(alreadySelected).map((tf:TypeFrais) => (
            <p key={tf.id}>{tf.name}
                <a className="btn btn-primary" onClick={() => { AddTypeFrais(tf); }}>+</a>
            </p>
        ))}


        <div>

        {type.map((e,idx)=>(
            <div key={e.type_frais_id} className="row">
                <div className="col-3">
                {e.name}
                </div>
                <div className="col-6">
                <FloatingPostfixInputBootStrap
                    name={`type_frais.${idx.toString()}.restriction`}
                    label={translate("fond_type_frais_restriction")}
                    type="number"
                    prefix="%"
                    errors={errors}
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    registerOutput= {register(`type_frais.${idx}.restriction`, {
                    
                    })} 
                />
                </div>
                <div className="col-3">
                <a className="btn btn-danger" onClick={() => { RemoveTypeFrais(idx); }}>X</a>
                </div>
            </div>

        ))}

        </div>

        </>
    ):null
    );
}


interface FondFraisSelectorInsertParams {
    type_frais:TypeFraisFond[],
    setValue: UseFormSetValue<FondInsert> ,
    register:UseFormRegister<FondInsert>,
    errors:FieldErrors<Partial<Fond>>
}

export function FondFraisSelectorInsert({type_frais,setValue,register,errors}:FondFraisSelectorInsertParams){
    const { data, error, isLoading } = useLookupTypeFraisQuery({});
    const {translate}=useTrads();

    const [type,setType]=useState<TypeFraisFond[]>(type_frais);
    function RemoveTypeFrais(idx: number){
        const tmp=type.filter((_,v)=> v!=idx );
        setType(tmp)
    }
    function AddTypeFrais(tmpfrais:TypeFrais){
        setType([...type,{name:tmpfrais.name,restriction:0,type_frais_id:tmpfrais.id,ordre:0,fond_id:0,description:''}])
    }

    function alreadySelected(tf:TypeFrais):boolean{
        return type.find(
            (elem:TypeFraisFond)=>elem.type_frais_id===tf.id
        )==undefined;
    }

     useEffect(()=>{
        setValue("type_frais",type);
     },[type,setValue])

     console.log(error);
    return (

    error ? (
       <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

    ) : isLoading ? (
        <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
    ) : data ? (
        <>
        {data.data.filter(alreadySelected).map((tf:TypeFrais) => (
            <p key={tf.id}>{tf.name}
                <a className="btn btn-primary" onClick={() => { AddTypeFrais(tf); }}>+</a>
            </p>
        ))}


        <div>

        {type.map((e,idx)=>(
            <div key={e.type_frais_id} className="row">
                <div className="col-3">
                {e.name}
                </div>
                <div className="col-6">
                <FloatingPostfixInputBootStrap
                    name={`type_frais.${idx.toString()}.restriction`}
                    label={translate("fond_type_frais_restriction")}
                    type="number"
                    prefix="%"
                    errors={errors}
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    registerOutput= {register(`type_frais.${idx}.restriction`, {
                    
                    })} 
                />
                </div>
                <div className="col-3">
                <a className="btn btn-danger" onClick={() => { RemoveTypeFrais(idx); }}>X</a>
                </div>
            </div>

        ))}

        </div>

        </>
    ):null
    );
}